/* eslint-disable quotes */
import detector from 'i18next-browser-languagedetector';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

const resources = {
    English: {
        translation: {
            assessmentSubmitBtn: 'Submit',
            singleSelector: 'Single Selection',
            multiSelector: 'Multi Selection',
            assessmentNotCompletedMsg: 'Please Answer All Mandatory Questions',
            assessmentCompletedMSg: 'Assessment Completed',
            errorMsg: 'No Data Found On MemberId',
            next: 'Next',
            prev: 'Previous',
            done: 'Done',
            assessmentValidation: 'Please Enter Valid Data',
            submitError: 'Sorry, an error occured. Please try to submit again',
            answerQuestion: 'Please answer the question.',
            textboxErrorMsg: "Please complete the textboxes marked as 'Others'.",
            enterValidAnswer: 'Enter valid answer',
            validEmail: 'Please Enter Valid Email',
            validZipCode: 'Please Enter Valid Zipcode',
            validNumber: 'Please enter a valid 10-digit number',
            SubmitForACallback: 'Submit for a callback',
            continueAssessment: 'Continue Assessment',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay',
            enterYourEmail: 'Enter your email'
        }
    },
    Spanish: {
        translation: {
            assessmentSubmitBtn: 'Completar',
            singleSelector: 'Selección única',
            multiSelector: 'Selección múltiple',
            assessmentNotCompletedMsg: 'Por favor, responda a todas las preguntas',
            assessmentCompletedMSg: 'Evaluación completada',
            errorMsg: 'No se encontraron datos en el ID de miembro',
            textboxErrorMsg: "Complete los cuadros de texto marcados como 'Otro'.",
            next: 'Siguiente',
            prev: 'Anterior',
            done: 'Completar',
            assessmentValidation: 'Por favor, introduzca datos válidos',
            validEmail: 'Por favor ingrese un correo electrónico válido',
            validZipCode: 'Por favor ingrese un código postal válido',
            validNumber: 'Por favor ingresa un número válido de 10 dígitos',
            submitError: 'Lo siento, ocurrió un error. Por favor, intenta enviar de nuevo',
            SubmitForACallback: 'Solicitar llamada',
            continueAssessment: 'Continuar evaluación',
            answerQuestion: 'Por favor, responda la pregunta.',
            enterValidAnswer: 'Introduce una respuesta válida',
            isInActiveTemplateMsg: 'Esta encuesta ya no está disponible.',
            enterYourEmail: 'Ingrese su respuesta'
        }
    },
    /*
     * Spanish: {
     *     translation: {
     *         assessmentSubmitBtn: 'Completar',
     *         singleSelector: 'Selección única',
     *         multiSelector: 'Selección múltiple',
     *         assessmentNotCompletedMsg: 'Por favor, responda a todas las preguntas',
     *         assessmentCompletedMSg: 'Evaluación completada',
     *         errorMsg: 'No se encontraron datos en el ID de miembro',
     *         textboxErrorMsg: "Complete los cuadros de texto marcados como 'Otro'.",
     *         next: 'Siguiente',
     *         prev: 'Anterior'
     *     }
     * },
     */
    Vietnamese: {
        translation: {
            assessmentSubmitBtn: 'Gửi Đi',
            singleSelector: 'Câu Hỏi Lựa Chọn Đơn',
            multiSelector: 'Câu Hỏi Đa Lựa Chọn',
            assessmentNotCompletedMsg: 'Vui lòng trả lời tất cả các câu hỏi bắt buộc',
            assessmentCompletedMSg: 'Đánh giá hoàn thành',
            errorMsg: 'Không tìm thấy dữ liệu về mã thành viên',
            next: 'Trang Kế Tiếp',
            prev: 'Quay Về Trang Trước',
            done: 'Xong',
            assessmentValidation: 'Vui lòng nhập dữ liệu hợp lệ',
            submitError: 'Xin lỗi, đã xảy ra lỗi. Vui lòng thử gửi lại',
            answerQuestion: 'Vui lòng trả lời câu hỏi.',
            textboxErrorMsg: 'Xin Vui Lòng Điền Vào Ô Trống Của Mục “Cái gì khác',
            enterValidAnswer: 'Nhập câu trả lời hợp lệ',
            validEmail: 'Vui lòng nhập email hợp lệ',
            validZipCode: 'Vui lòng nhập mã bưu điện hợp lệ',
            validNumber: 'Vui lòng nhập số điện thoại 10 chữ số hợp lệ',
            SubmitForACallback: 'Gửi để nhận cuộc gọi lại',
            continueAssessment: 'Tiếp tục đánh giá',
            isInActiveTemplateMsg: 'Esta encuesta ya no está disponible.',
            confirm: 'Confirmation',
            ok: 'Okay'
        }
    },
    Español: {
        translation: {
            assessmentSubmitBtn: 'Completar',
            singleSelector: 'Selección única',
            multiSelector: 'Selección múltiple',
            assessmentNotCompletedMsg: 'Por favor, responda a todas las preguntas',
            assessmentCompletedMSg: 'Evaluación completada',
            errorMsg: 'No se encontraron datos en el ID de miembro',
            next: 'Siguiente',
            prev: 'Anterior',
            done: 'Completar',
            assessmentValidation: 'Por favor, introduzca datos válidos',
            submitError: 'Lo siento, ocurrió un error. Por favor, intenta enviar de nuevo',
            answerQuestion: 'Por favor, responda la pregunta.',
            textboxErrorMsg: "Por favor complete los cuadros de texto marcados 'Algo más.",
            enterValidAnswer: 'Introduce una respuesta válida',
            validEmail: 'Por favor ingrese un correo electrónico válido',
            validZipCode: 'Por favor ingrese un código postal válido',
            validNumber: 'Por favor ingresa un número válido de 10 dígitos',
            SubmitForACallback: 'Solicitar llamada',
            continueAssessment: 'Continuar evaluación',
            isInActiveTemplateMsg: 'Esta encuesta ya no está disponible.',
            confirm: 'Confirmación',
            ok: 'Bueno',
            enterYourEmail: 'Ingrese su respuesta'
        }
    },
    العربية: {
        translation: {
            assessmentSubmitBtn: 'إرسال',
            singleSelector: 'اختيار فردي',
            multiSelector: 'اختيار متعدد',
            assessmentNotCompletedMsg: 'يرجى الإجابة على جميع الأسئلة',
            assessmentCompletedMSg: 'اكتمل التقييم',
            errorMsg: 'لم يتم العثور على بيانات على معرف العضو',
            next: 'التالي',
            prev: 'السابق',
            done: 'تم',
            assessmentValidation: 'من فضلك أدخل بيانات صحيحة',
            submitError: 'آسف، حدث خطأ. يرجى المحاولة مرة أخرى',
            textboxErrorMsg: 'الرجاء إكمال مربعات النص المميزة بـ شيء آخر.',
            enterValidAnswer: 'أدخل إجابة صحيحة',
            validEmail: 'الرجاء إدخال بريد إلكتروني صالح',
            validZipCode: 'الرجاء إدخال الرمز البريدي صالح',
            validNumber: 'الرجاء إدخال رقم صالح مكون من 10 أرقام',
            SubmitForACallback: 'إرسال للحصول على رد الاتصال',
            continueAssessment: 'مواصلة التقييم',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay'
        }
    },
    Chinese: {
        translation: {
            assessmentSubmitBtn: '提交',
            singleSelector: '单选',
            multiSelector: '多选',
            assessmentNotCompletedMsg: '请回答所有必填问题',
            assessmentCompletedMSg: '评估完成',
            errorMsg: '未找到会员ID的数据',
            next: '下一个',
            prev: '上一个',
            done: '完成',
            assessmentValidation: ' 请输入有效数据',
            submitError: '抱歉，发生错误。请再试一次提交',
            textboxErrorMsg: '请填写标有“其他内容”的文本框。',
            enterValidAnswer: '输入有效答案',
            validEmail: '請輸入有效的電子郵件',
            validZipCode: '請輸入有效的郵遞區號',
            validNumber: '請輸入有效的 10 位數字',
            SubmitForACallback: '提交回调',
            continueAssessment: '继续评估',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay'
        }
    },
    Russian: {
        translation: {
            assessmentSubmitBtn: 'Отправить',
            singleSelector: 'Одиночный выбор',
            multiSelector: 'Множественный выбор',
            assessmentNotCompletedMsg: 'Пожалуйста, ответьте на все обязательные вопросы',
            assessmentCompletedMSg: 'Оценка завершена',
            errorMsg: 'Данные по MemberId не найдены',
            next: 'Следующий',
            prev: 'Предыдущий',
            done: 'Готово',
            assessmentValidation: ' Пожалуйста, введите правильные данные',
            submitError: 'Извините, произошла ошибка. Пожалуйста, попробуйте отправить еще раз',
            textboxErrorMsg: 'Пожалуйста, заполните текстовые поля с пометкой «Что-то еще».',
            enterValidAnswer: 'Введите действительный ответ',
            validEmail: 'Пожалуйста, введите действительный адрес электронной почты',
            validZipCode: 'Пожалуйста, введите действительный почтовый индекс',
            validNumber: 'Пожалуйста, введите действительный 10-значный номер',
            SubmitForACallback: 'Отправьте заявку на обратный звонок',
            continueAssessment: 'Продолжить оценку',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay'
        }
    },
    Português: {
        translation: {
            assessmentSubmitBtn: 'Completar',
            singleSelector: 'Seleção única',
            multiSelector: 'Seleção múltipla',
            assessmentNotCompletedMsg: 'Por favor, responda a todas as perguntas obrigatórias',
            assessmentCompletedMSg: 'Avaliação completa',
            errorMsg: 'Nenhum dado encontrado no ID de membro',
            next: 'Próximo',
            prev: 'Anterior',
            done: 'Concluído',
            assessmentValidation: 'Por favor, insira dados válidos',
            submitError: 'Desculpe, ocorreu um erro. Por favor, tente enviar novamente',
            textboxErrorMsg: "Por favor preencha as caixas de texto marcadas como 'Outra coisa'.",
            enterValidAnswer: 'Insira uma resposta válida',
            validEmail: 'Por favor insira um e-mail válido',
            validZipCode: 'Por favor insira o CEP válido',
            validNumber: 'Insira um número válido de 10 dígitos',
            SubmitForACallback: 'Enviar para um retorno de chamada',
            continueAssessment: 'Continuar avaliação',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay',
            enterYourEmail: 'Endereço de e-mail'
        }
    },
    Korean: {
        translation: {
            assessmentSubmitBtn: '제출',
            singleSelector: '단일 선택',
            multiSelector: '다중 선택',
            assessmentNotCompletedMsg: '모든 필수 질문에 답하십시오',
            assessmentCompletedMSg: '평가 완료',
            errorMsg: '회원 ID에서 데이터를 찾을 수 없습니다',
            next: '다음',
            prev: '이전',
            done: '완료',
            assessmentValidation: ' 유효한 데이터를 입력해주세요',
            submitError: '죄송합니다. 오류가 발생했습니다. 다시 제출해 주세요',
            textboxErrorMsg: '‘기타’라고 표시된 텍스트 상자를 작성하세요.',
            enterValidAnswer: '유효한 답변을 입력하세요',
            validEmail: '유효한 이메일을 입력해주세요',
            validZipCode: '유효한 우편번호를 입력하세요',
            validNumber: '유효한 10자리 숫자를 입력하세요.',
            SubmitForACallback: '콜백을 위해 제출',
            continueAssessment: '계속 평가',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay'
        }
    },
    '中文（简体)': {
        translation: {
            assessmentSubmitBtn: '提交',
            singleSelector: '单选',
            multiSelector: '多选',
            assessmentNotCompletedMsg: '请回答所有必填问题',
            assessmentCompletedMSg: '评估完成',
            errorMsg: '未找到会员ID的数据',
            next: '下一个',
            prev: '上一个',
            done: '完成',
            assessmentValidation: '请填写有效数据',
            submitError: '抱歉，發生錯誤。請再次嘗試提交',
            textboxErrorMsg: '請填寫標有「其他內容」的文字方塊。',
            enterValidAnswer: '輸入有效答案',
            validEmail: '请输入有效的电子邮件',
            validZipCode: '请输入有效的邮政编码',
            validNumber: '请输入有效的 10 位数字',
            isInActiveTemplateMsg: 'This survey is no longer available.',
            confirm: 'Confirmation',
            ok: 'Okay'
        }
    },
    '中文 (简体)': {
        translation: {
            enterYourEmail: '请输入您的电邮地址',
            next: '下一页',
            prev: '上一页',
            assessmentSubmitBtn: '提交',
            done: '完成',
            singleSelector: '单选项',
            multiSelector: '多选项'
        }
    }
};

/*
 * const language = localStorage.getItem('I18N_LANGUAGE');
 * const language = localStorage.getItem('I18N_LANGUAGE') || 'English';
 */

i18n.use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(new LanguageDetector(null, { lookupLocalStorage: 'I18N_LANGUAGE' }))

    .init({
        resources,
        // lng: language,
        debug: true,
        fallbackLng: 'English',
        returnObjects: true,
        keySeparator: false,

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
